// MyIcon.tsx
import { bundleIcon, FluentIconsProps, wrapIcon } from '@fluentui/react-icons'
import * as React from 'react'

export const ProofMeOutlineIcon = wrapIcon((props: FluentIconsProps) => {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="1rem"
            height="1rem"
            viewBox="0 0 220.000000 220.000000"
            preserveAspectRatio="xMidYMid meet"
            {...props}
        >
            <g transform="translate(0.000000,220.000000) scale(0.100000,-0.100000)" fill="#0078d4" stroke="none">
                <path
                    d="M597 1712 c-142 -36 -256 -153 -286 -293 -12 -52 -7 -158 8 -207 32
-105 126 -206 228 -245 65 -25 95 -28 275 -29 l167 -1 3 -209 3 -210 30 -24
c39 -31 111 -33 148 -4 38 30 43 64 42 263 0 98 2 180 6 182 3 3 89 5 190 6
170 2 189 4 247 26 84 33 162 106 201 186 36 73 42 100 42 187 -1 162 -97 302
-249 361 -54 21 -74 22 -359 23 l-303 2 0 -288 0 -288 -157 0 c-139 0 -162 2
-201 21 -105 51 -132 188 -55 280 40 47 79 62 163 63 l75 2 3 104 3 105 -87 0
c-48 0 -109 -5 -137 -13z m976 -217 c107 -51 135 -190 56 -280 -49 -56 -92
-66 -264 -63 l-150 3 -1 170 c0 94 1 175 3 180 2 7 61 10 161 10 130 -1 163
-4 195 -20z"
                />
            </g>
        </svg>
    )
}, 'ProofMeOutlineIcon')

export const ProofMeFilledIcon = wrapIcon((props: FluentIconsProps) => {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="1rem"
            height="1rem"
            viewBox="0 0 220.000000 220.000000"
            preserveAspectRatio="xMidYMid meet"
            {...props}
        >
            <g transform="translate(0.000000,220.000000) scale(0.100000,-0.100000)" fill="#107c10" stroke="none">
                <path
                    d="M597 1712 c-142 -36 -256 -153 -286 -293 -12 -52 -7 -158 8 -207 32
-105 126 -206 228 -245 65 -25 95 -28 275 -29 l167 -1 3 -209 3 -210 30 -24
c39 -31 111 -33 148 -4 38 30 43 64 42 263 0 98 2 180 6 182 3 3 89 5 190 6
170 2 189 4 247 26 84 33 162 106 201 186 36 73 42 100 42 187 -1 162 -97 302
-249 361 -54 21 -74 22 -359 23 l-303 2 0 -288 0 -288 -157 0 c-139 0 -162 2
-201 21 -105 51 -132 188 -55 280 40 47 79 62 163 63 l75 2 3 104 3 105 -87 0
c-48 0 -109 -5 -137 -13z m976 -217 c107 -51 135 -190 56 -280 -49 -56 -92
-66 -264 -63 l-150 3 -1 170 c0 94 1 175 3 180 2 7 61 10 161 10 130 -1 163
-4 195 -20z"
                />
            </g>
        </svg>
    )
}, 'ProofMeFilledIcon')

export const ProofMeIcon = bundleIcon(ProofMeFilledIcon, ProofMeOutlineIcon)
